export default function initHeadingAnchors() {
    const content = document.querySelector('.gh-content');
    if (!content) return;

    const headings = content.querySelectorAll('h1, h2, h3, h4, h5, h6');
    const usedIds = new Set();

    headings.forEach(heading => {
        const text = heading.textContent || '';
        let slug = text
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .trim()
            .replace(/[\s_]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');

        if (!slug) return;

        let id = slug;
        let counter = 1;
        while (usedIds.has(id)) {
            id = `${slug}-${counter}`;
            counter++;
        }
        usedIds.add(id);
        heading.id = id;
    });
}
